export default "__VITE_ASSET___k1B7K1r__"